<template>
      <div>
            <!-- Label -->
            <div class="flex xs-12 xs-between">
                  <label class="fs3 c6 fw6 mb1">{{ $t("quote_status") }}</label>
                  <div v-if="value !== 'all'" class="fs3 cu2 cError" @click="handleReset">{{ $t("clear") }}</div>
            </div>

            <!-- Select -->
            <j-base-select
                  :allowSelectNothing="false"
                  :value="value"
                  :size="size"
                  :options="policyStatusOptions"
                  @input="$emit('input', $event)"
            />
      </div>
</template>

<script>
import JBaseSelect from "@/components/JBaseSelect/"

export default {
	components: { JBaseSelect },
	props: ["value", "size"],

	data() {
		return {
			policyStatusOptions: [
				{ name: this.$t("all"), value: "all" },
				{ name: this.$t("only_quoting"), value: "QUOTING" },
				{ name: this.$t("only_rejected"), value: "REJECTED" }
			]
		}
	},

	methods: {
		handleReset() {
			this.$emit("input", "all")
		}
	}
}
</script>
